import { render, staticRenderFns } from "./VDatePeriod.vue?vue&type=template&id=5de916ce&"
import script from "./VDatePeriod.vue?vue&type=script&lang=ts&"
export * from "./VDatePeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports